import React, { useState, useEffect } from "react";
import apiService from "apiService";
import Select2 from "react-select";
import Alert from "view/component/Alert";
import "react-datepicker/dist/react-datepicker.css";

const DrugCounseling = (props) => {
  const [param, setParam] = useState({
    visit_id: props.detilPx.id,
    id: null,
    subject: "",
    drugs_name: false,
    dosage: false,
    usage: false,
    note: ""
  });

  const getDrugCounseling = async () => {
    let res = await apiService.get(
      "/registration/drugs_counselings/read/" + props.detilPx.id
    );
    if (res && res.code === 200) {
      setParam({
        ...param,
        id: res.data.id,
        subject: res.data.subject,
        drugs_name:res.data.drugs_name,
        dosage:res.data.dosage,
        usage:res.data.usage,
        note: res.data.note
      });
    }
  };

  useEffect(() => {
    getDrugCounseling();
  }, [param.length]);

  const postParam = async () => {
    let res;
    if (param.id)
      res = await apiService.put(
        "/registration/drugs_counselings/update",
        param
      );
    else
      res = await apiService.post(
        "/registration/drugs_counselings/create",
        param
      );
    if (res.code === 200) {
      Alert("success", "data disimpan");
    } else {
      Alert("error", "gagal menyimpan data");
    }
    getDrugCounseling();
  };

  return (
    <div>
      <div className='card'>
        <div className='card-header'>
          <div className='row align-items-center'>
            <div className='col'>
              <h4 className='h3 mb-0'>Dokumentasi Konseling Pasien Rawat Jalan</h4>
            </div>
          </div>
        </div>
        <div className='card-body'>
          <div className='row'>
            <div className='col-12'>
              <div className='form-group'>
                <label className='form-control-label text-default'>
                  Perihal
                </label>
                <textarea
                  className='form-control'
                  onChange={(e) =>
                    setParam({ ...param, subject: e.target.value })
                  }
                  rows='3'
                  value={param.subject}
                />
              </div>
            </div>
            <div className='col-12'>
              <label className='form-control-label text-default'>
                Terapi
              </label>
            </div>
            <div className='col-md-4 mb-3'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  checked={param.drugs_name ? 'checked' : ''}
                  id='customCheck13'
                  onChange={(e) =>
                    setParam({ ...param, drugs_name: !param.drugs_name })
                  }
                />
                <label class='custom-control-label' for='customCheck13'>
                  Nama Obat
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-3'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  checked={param.dosage ? 'checked' : ''}
                  id='customCheck14'
                  onChange={(e) => setParam({ ...param, dosage: !param.dosage })}
                />
                <label class='custom-control-label' for='customCheck14'>
                  Dosis
                </label>
              </div>
            </div>
            <div className='col-md-4 mb-3'>
              <div class='custom-control custom-checkbox'>
                <input
                  type='checkbox'
                  class='custom-control-input'
                  id='customCheck15'
                  checked={param.usage ? 'checked' : ''}
                  onChange={(e) =>
                    setParam({ ...param, usage: !param.usage })
                  }
                />
                <label class='custom-control-label' for='customCheck15'>
                  Cara Pemakaian
                </label>
              </div>
            </div>
            <div className='col-12'>
              <div className='form-group'>
                <label className='form-control-label text-default'>
                  Catatan Pelayanan Konseling Apoteker
                </label>
                <textarea
                  className='form-control'
                  onChange={(e) =>
                    setParam({ ...param, note: e.target.value })
                  }
                  rows='3'
                  value={param.note}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='card-footer'>
          <div className='btn btn-primary' onClick={() => postParam()}>
            Simpan Dokumentasi
          </div>
        </div>
      </div>
      {/* <div className='accordion' id='accordionLog'>
        <div className='card'>
          <div
            className='card-header'
            id={"heading"}
            data-toggle='collapse'
            data-target={"#collapse"}
            aria-expanded='false'
            aria-controls={"collapse"}>
            <div className='h3 text-default mb-0'>Log Riwayat Kehamilan</div>
          </div>
          <div
            id={"collapse"}
            className='collapse'
            aria-labelledby={"heading"}
            data-parent='#accordionLog'>
            <div className='card-body bg-light'>
              <div className='accordion'></div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};
export default DrugCounseling;
